export { SizedBox } from './CircledNumber';
export type { SizedBoxVariants } from './CircledNumber.css';
